var v3714;
var v3715;
(function (p3894) {
  v3714 = [];
  if ((v3715 = function () {
    function t(p3895) {
      if (typeof p3895 == "string") {
        return p3895.replace(/[\+ \|\^\%]/g, function (p3896) {
          return {
            " ": "+",
            "+": "%2B",
            "|": "%7C",
            "^": "%5E",
            "%": "%25"
          }[p3896];
        });
      } else {
        return p3895;
      }
    }
    function f292(p3897) {
      if (typeof p3897 == "string") {
        return p3897.replace(/\+|%2B|%7C|%5E|%25/g, function (p3898) {
          return {
            "+": " ",
            "%2B": "+",
            "%7C": "|",
            "%5E": "^",
            "%25": "%"
          }[p3898];
        });
      } else {
        return p3897;
      }
    }
    function f293(p3899) {
      return Number.prototype.toString.call(p3899, 36).toUpperCase();
    }
    function f294(p3900) {
      return parseInt(p3900, 36);
    }
    var v3716 = Array.prototype.indexOf || function (p3901, p3902) {
      for (var v3717 = p3902 || 0, v3718 = this.length; v3717 < v3718; v3717++) {
        if (this[v3717] === p3901) {
          return v3717;
        }
      }
      return -1;
    };
    return {
      JSON: JSON,
      pack: function (p3903, p3904) {
        var v3719 = (p3904 = p3904 || {}).verbose || false;
        if (v3719) {
          console.log("Normalize the JSON Object");
        }
        p3903 = typeof p3903 == "string" ? this.JSON.parse(p3903) : p3903;
        if (v3719) {
          console.log("Creating a empty dictionary");
        }
        var vO110 = {
          strings: [],
          integers: [],
          floats: []
        };
        if (v3719) {
          console.log("Creating the AST");
        }
        var vE3 = function f295(p3905) {
          if (v3719) {
            console.log("Calling recursiveAstBuilder with " + this.JSON.stringify(p3905));
          }
          var v3720;
          var v3721 = typeof p3905;
          if (p3905 === null) {
            return {
              type: "null",
              index: -3
            };
          }
          if (typeof p3905 == "undefined") {
            return {
              type: "undefined",
              index: -5
            };
          }
          if (p3905 instanceof Array) {
            var vA205 = ["@"];
            for (var v3722 in p3905) {
              if (p3905.hasOwnProperty(v3722)) {
                vA205.push(f295(p3905[v3722]));
              }
            }
            return vA205;
          }
          if (v3721 == "object") {
            vA205 = ["$"];
            for (var v3723 in p3905) {
              if (p3905.hasOwnProperty(v3723)) {
                vA205.push(f295(v3723));
                vA205.push(f295(p3905[v3723]));
              }
            }
            return vA205;
          }
          if (p3905 === "") {
            return {
              type: "empty",
              index: -4
            };
          }
          if (v3721 == "string") {
            if ((v3720 = v3716.call(vO110.strings, p3905)) == -1) {
              vO110.strings.push(t(p3905));
              v3720 = vO110.strings.length - 1;
            }
            return {
              type: "strings",
              index: v3720
            };
          }
          if (v3721 == "number" && p3905 % 1 == 0) {
            if ((v3720 = v3716.call(vO110.integers, p3905)) == -1) {
              vO110.integers.push(f293(p3905));
              v3720 = vO110.integers.length - 1;
            }
            return {
              type: "integers",
              index: v3720
            };
          }
          if (v3721 == "number") {
            if ((v3720 = v3716.call(vO110.floats, p3905)) == -1) {
              vO110.floats.push(p3905);
              v3720 = vO110.floats.length - 1;
            }
            return {
              type: "floats",
              index: v3720
            };
          }
          if (v3721 == "boolean") {
            return {
              type: "boolean",
              index: p3905 ? -1 : -2
            };
          }
          throw new Error("Unexpected argument of type " + typeof p3905);
        }(p3903);
        var v3724 = vO110.strings.length;
        var v3725 = vO110.integers.length;
        vO110.floats.length;
        if (v3719) {
          console.log("Parsing the dictionary");
        }
        var v3726 = vO110.strings.join("|");
        v3726 += "^" + vO110.integers.join("|");
        v3726 += "^" + vO110.floats.join("|");
        if (v3719) {
          console.log("Parsing the structure");
        }
        v3726 += "^" + function f296(p3906) {
          if (v3719) {
            console.log("Calling a recursiveParser with " + this.JSON.stringify(p3906));
          }
          if (p3906 instanceof Array) {
            var v3727 = p3906.shift();
            for (var v3728 in p3906) {
              if (p3906.hasOwnProperty(v3728)) {
                v3727 += f296(p3906[v3728]) + "|";
              }
            }
            return (v3727[v3727.length - 1] === "|" ? v3727.slice(0, -1) : v3727) + "]";
          }
          var v3729 = p3906.type;
          var v3730 = p3906.index;
          if (v3729 === "strings") {
            return f293(v3730);
          }
          if (v3729 === "integers") {
            return f293(v3724 + v3730);
          }
          if (v3729 === "floats") {
            return f293(v3724 + v3725 + v3730);
          }
          if (v3729 === "boolean") {
            return p3906.index;
          }
          if (v3729 === "null") {
            return -3;
          }
          if (v3729 === "undefined") {
            return -5;
          }
          if (v3729 === "empty") {
            return -4;
          }
          throw new TypeError("The item is alien!");
        }(vE3);
        if (v3719) {
          console.log("Ending parser");
        }
        if (p3904.debug) {
          return {
            dictionary: vO110,
            ast: vE3,
            packed: v3726
          };
        } else {
          return v3726;
        }
      },
      unpack: function (p3907, p3908) {
        p3908 = p3908 || {};
        var v3731 = p3907.split("^");
        if (p3908.verbose) {
          console.log("Building dictionary");
        }
        var vA206 = [];
        var v3732 = v3731[0];
        if (v3732 !== "") {
          v3732 = v3732.split("|");
          if (p3908.verbose) {
            console.log("Parse the strings dictionary");
          }
          for (var vLN0563 = 0, v3733 = v3732.length; vLN0563 < v3733; vLN0563++) {
            vA206.push(f292(v3732[vLN0563]));
          }
        }
        if ((v3732 = v3731[1]) !== "") {
          v3732 = v3732.split("|");
          if (p3908.verbose) {
            console.log("Parse the integers dictionary");
          }
          vLN0563 = 0;
          v3733 = v3732.length;
          for (; vLN0563 < v3733; vLN0563++) {
            vA206.push(f294(v3732[vLN0563]));
          }
        }
        if ((v3732 = v3731[2]) !== "") {
          v3732 = v3732.split("|");
          if (p3908.verbose) {
            console.log("Parse the floats dictionary");
          }
          vLN0563 = 0;
          v3733 = v3732.length;
          for (; vLN0563 < v3733; vLN0563++) {
            vA206.push(parseFloat(v3732[vLN0563]));
          }
        }
        v3732 = null;
        if (p3908.verbose) {
          console.log("Tokenizing the structure");
        }
        var v3734;
        var vLS6 = "";
        var vA207 = [];
        var v3735 = v3731[3].length;
        for (vLN0563 = 0; vLN0563 < v3735; vLN0563++) {
          if ((v3734 = v3731[3].charAt(vLN0563)) === "|" || v3734 === "$" || v3734 === "@" || v3734 === "]") {
            if (vLS6) {
              vA207.push(f294(vLS6));
              vLS6 = "";
            }
            if (v3734 !== "|") {
              vA207.push(v3734);
            }
          } else {
            vLS6 += v3734;
          }
        }
        var v3736 = vA207.length;
        var vLN0564 = 0;
        if (p3908.verbose) {
          console.log("Starting recursive parser");
        }
        return function f297() {
          var v3737 = vA207[vLN0564++];
          if (p3908.verbose) {
            console.log("Reading collection type " + (v3737 === "$" ? "object" : "Array"));
          }
          if (v3737 === "@") {
            var vA208 = [];
            for (; vLN0564 < v3736; vLN0564++) {
              v3739 = vA207[vLN0564];
              if (p3908.verbose) {
                console.log("Read " + v3739 + " symbol");
              }
              if (v3739 === "]") {
                return vA208;
              }
              if (v3739 === "@" || v3739 === "$") {
                vA208.push(f297());
              } else if (v3739 === -1) {
                vA208.push(true);
              } else if (v3739 === -2) {
                vA208.push(false);
              } else if (v3739 === -3) {
                vA208.push(null);
              } else if (v3739 === -5) {
                vA208.push(undefined);
              } else if (v3739 === -4) {
                vA208.push("");
              } else {
                vA208.push(vA206[v3739]);
              }
            }
            if (p3908.verbose) {
              console.log("Parsed " + this.JSON.stringify(vA208));
            }
            return vA208;
          }
          if (v3737 === "$") {
            var v3738;
            for (vA208 = {}; vLN0564 < v3736; vLN0564++) {
              if ((v3738 = vA207[vLN0564]) === "]") {
                return vA208;
              }
              v3738 = v3738 === -4 ? "" : vA206[v3738];
              var v3739 = vA207[++vLN0564];
              vA208[v3738] = v3739 === "@" || v3739 === "$" ? f297() : v3739 === -1 || v3739 !== -2 && (v3739 === -3 ? null : v3739 === -5 ? undefined : v3739 === -4 ? "" : vA206[v3739]);
            }
            if (p3908.verbose) {
              console.log("Parsed " + this.JSON.stringify(vA208));
            }
            return vA208;
          }
          throw new TypeError("Bad token " + v3737 + " isn't a type");
        }();
      }
    };
  }.apply(exports, v3714)) !== undefined) {
    module.exports = v3715;
  }
})(require("./define.js"));